import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Moment from 'moment';
import React from 'react';
import { useQuery } from '../hooks/useQuery';
import IconButton from '@mui/material/IconButton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import BasicSpeedDial from './SpeedDial';
import CustomChip from './CustomChip';
import { obterCorPorStatus } from '../utils';

const RowPagamentoDireto = ({
  pagamento,
  index,
  onClickEdit,
  onClickDelete,
  clickExpand,
}) => {
  const [statuses, setStatuses] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const {
    obterHistoricoStatusPagamentoDireto,
    enviarPagamentoDireto,
    getStatusFluig,
  } = useQuery();
  const { isUsuarioSebrae, user } = useAuth();

  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const onChangeAccordtion = (e, expanded) => {
    if (expanded) {
      obterHistoricoStatus();
    }
  };

  const onClickWorkflow = (pagamento) => {
    window.open(
      `${process.env.REACT_APP_URL_FLUIG}/portal/p/1/pageworkflowview?app_ecm_workflowview_detailsProcessInstanceID=${pagamento.numero_processo_fluig}`,
      '_blank',
    );
  };

  const obterHistoricoStatus = (e) => {
    setIsLoading(true);
    if (
      pagamento.tipo_documento == 'fundoFixo' ||
      pagamento.tipo_documento == 'cancelaVendaDevolucao'
    ) {
      getStatusFluig(pagamento.numero_processo_fluig)
        .then(({ data }) => {
          setStatuses(data);
          setIsLoading(false);
        })
        .catch((e) => setIsLoading(false));
    } else {
      obterHistoricoStatusPagamentoDireto(pagamento.id)
        .then(({ data }) => {
          let find = false;
          let dataModify = [];
          data.forEach((element, index) => {
            if (element.desc_movto == 'AGUARDANDO PAGAMENTO') {
              if (!find) {
                dataModify.push(element);
              }
              find = true;
            } else {
              dataModify.push(element);
            }
          });
          setStatuses(dataModify);
          if (data && data.length > 0) {
            console.log('open', data);
            pagamento.status =
              pagamento.situacao_nf == 'CANCELADO'
                ? 'CANCELADO'
                : data[0].desc_movto;
            // enviarPagamentoDireto(pagamento);
          }

          setIsLoading(false);
        })
        .catch((e) => setIsLoading(false));
    }
  };

  const onClickCancel = async (pagamento) => {
    navigate(`/dashboard/cancelar-pagamento-direto/${pagamento.id}`);
  };

  return (
    <tr
      key={`row${index}`}
      style={{
        border: '2px solid #FAFCFF',
        background: index % 2 === 0 ? 'white' : '#f0eded',
      }}
    >
      <td align="center">{pagamento.numero_processo_fluig}</td>
      <td align="center">{pagamento.numero_fiscal}</td>
      <td align="center">
        {/* <CustomChip label={pagamento.status} status={pagamento.status} /> */}
        <Button
          style={{
            borderRadius: 20,
            width: '100%',
            fontSize: 10,
          }}
          variant="outlined"
          color={obterCorPorStatus(pagamento.status)}
        >
          {pagamento.status}
        </Button>
      </td>

      <td align="center">
        {Moment(pagamento.created_at).format('DD/MM/YYYY')}
      </td>
      <td align="center">{pagamento.fornecedor}</td>
      <td align="center">
        {pagamento.tipo_documento == 'cancelaVendaDevolucao'
          ? 'cancelaVenda'
          : pagamento.tipo_documento}
      </td>
      <td>
        <IconButton onClick={() => clickExpand()}>
          <ExpandMoreIcon />
        </IconButton>
      </td>
      <td
        style={{
          paddingLeft: '2.5rem',
          width: '5%',
        }}
      >
        <BasicSpeedDial
          onClickEdit={onClickEdit}
          onClickCancel={onClickCancel}
          onClickDelete={onClickDelete}
          onClickWorkflow={onClickWorkflow}
          pagamento={pagamento}
        />
      </td>

      {/* <td colSpan={7}>
        <Accordion
          style={{
            padding: 0,
            boxShadow: 'none',
            borderBottom: 'solid 1px #ddd',
          }}
          onChange={onChangeAccordtion}
        >
          <AccordionSummary
            style={{
              padding: 0,
              background: index % 2 === 0 ? 'white' : '#f0eded',
            }}
            aria-controls={'panel-content' + index}
            id={'panel-header' + index}
          >
            <table style={{ width: '100%' }}>
              <tbody>

              </tbody>
            </table>
          </AccordionSummary>
          <AccordionDetails>
            {isLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress />
              </Box>
            ) : (
              <PagamentoItem pagamento={pagamento} statuses={statuses} />
            )}
          </AccordionDetails>
        </Accordion>
      </td> */}
    </tr>
  );
};

export default RowPagamentoDireto;
